<template>

  <div v-if="sitio !== null" class="position-relative" style="min-height: 100vh">

    <div class="d-flex position-absolute" style="top: 10px; right: 10px">
      <button v-for="(idioma, index) in sitio.locales"
              :key="index"
              @click="setLocale(idioma)"
              class="button-idioma me-2">
        <img :src="sitio.locales_info[idioma].bandera" :alt="idioma" class="bandera-img">
      </button>
    </div>

    <div class="w-100">
      <div style="width: 80%" class="d-none d-md-block m-auto">
        <img style="width: 100%" :src="sitio.logo_url">
      </div>
      <div style="width: 100%" class="d-block d-md-none m-auto">
        <img style="width: 100%" :src="sitio.logo_url">
      </div>
    </div>

    <div class="p-3">
      <router-link
          v-for="m in publicableMenus"
          :key="m.id"
          :to="`${this.$route.params.sitio}/menu/${m.id}`"
          class="glass-card d-block p-3 text-center mb-3 font-600 text-decoration-none">
        {{ m.nombre }}
      </router-link>

      <div v-if="sitio.iconos && sitio.iconos.length > 0"
           class="glass-card width-100 p-3 position-relative"
           style="z-index: 999;">
        <div v-for="icono in sitio.iconos" :key="icono.id" class="d-flex mb-3">
          <div style="width: 70px;" class="icons-container">
            <img :src="icono.url" style="width: 42px;">
          </div>
          <div>
            <div class="font-weight-bold">{{ icono.nombre }}</div>
          </div>
        </div>

        <div class="d-flex">
          <ModalComponent :title="i18n.take_away_title">
            <template #button>
              <div style="width: 70px;" class="cursor-pointer icons-container">
                <img
                    src="https://sethotels.ams3.cdn.digitaloceanspaces.com/carta-digital/icon_buffet_take_away.svg"
                    style="width: 42px;"/>
              </div>
            </template>

            <div class="p-3 pt-0 pb-0">
              {{ i18n.take_away_text }}
            </div>
          </ModalComponent>
        </div>

        <div class="position-relative text-right position-absolute"
             style="font-size: 12px; right: 15px; bottom: 15px">
          <div class="font-weight-bold">IVA Incluido</div>
          <div class="font-weight-light">VAT included</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ModalComponent from "@/components/ModalComponent.vue";
import {getI18n} from "@/locales/locales";

export default {
  name: 'HomeView',
  components: {ModalComponent},

  computed: {
    sitio() {
      return this.$store.getters['sitio/sitio'];
    },
    publicableMenus() {
      return this.sitio.menus.filter((m) => m.publicable);
    },
    i18n() {
      return getI18n();
    },
  },

  methods: {
    setLocale(locale) {
      localStorage.locale = locale;
      location.reload();
    }
  },
}
</script>

<style scoped>
.button-idioma {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
}

.bandera-img {
  height: 26px;
  width: 36px;
  border-radius: 4px;
  object-fit: cover;
  display: block;
}

#topNav {
  width: 100%;
  backdrop-filter: blur(15px);
  background-color: rgba(240, 240, 240, 0.5)
}

.content-link div {
  width: 100%;
  text-decoration: none !important;
  padding: 5px 20px;
  border-radius: 15px;
}

.content-link:hover div {
  background-color: #f5f5f5;
  font-weight: 500;
}

.router-link-exact-active div {
  background-color: #f5f5f5;
  font-weight: 500;
}
</style>
